








































import Vue from 'vue'
import { sprintf } from 'sprintf-js'
import { getText } from '../js/lang'
import TicketPreview from './ticket-preview.vue'

interface Stamp {
  pos: [number, number]
  rot: number
}

interface Ticket {
  publish_id: string
  ticket_id: string
  name: string
  country_code?: string
  stamps: Stamp[]
}

export default Vue.extend({
  name: 'published-view',
  components: { TicketPreview },
  props: {
    lang: {
      type: String,
      required: true
    },
    ticket: {
      type: Object as () => Ticket,
      required: true
    },
    ticketId: {
      type: String,
      required: true
    }
  },
  // computed: {
  //   ticketId(): string {
  //     return sprintf(
  //       '%s-%s',
  //       this.ticket.ticket_id || 'HAYA2-EX-****-****',
  //       this.ticket.country_code || '**',
  //     )
  //   }
  // },
  methods: {
    l(key: string, ...values: any[]): string {
      return sprintf(getText(this.lang, key), ...values)
    }
  }
})
